import { createAction, createReducer } from '@reduxjs/toolkit';
import { CHNode } from '../../../general/node';
import { TrashCHNode } from './types';

export type TrashShape = {
  list: TrashCHNode[];
  listLoading: boolean;
  selected: CHNode['id'][];
};

export const TrashActions = {
  updateRequested: createAction<void, 'ch/trash/updateRequested'>('ch/trash/updateRequested'),
  putBackRequested: createAction<{ nodes: CHNode[] }, 'ch/trash/putBackRequested'>(
    'ch/trash/putBackRequested',
  ),
  update: createAction<{ nodes: TrashCHNode[]; loading: boolean }, 'ch/trash/update'>(
    'ch/trash/update',
  ),
  setSelected: createAction<
    { id: CHNode['id']; selected: boolean; shift: boolean },
    'ch/trash/setSelected'
  >('ch/trash/setSelected'),
  selectorAllChanged: createAction<{ ids: CHNode['id'][] }, 'ch/trash/selectorAllChanged'>(
    'ch/trash/selectorAllChanged',
  ),
};

export const trash = createReducer<TrashShape>(
  { list: [], selected: [], listLoading: true },
  (build) => {
    build
      .addCase(TrashActions.update, (s, a) => {
        s.list = a.payload.nodes;
        s.listLoading = a.payload.loading;
        s.selected = [];
      })
      .addCase(TrashActions.setSelected, (s, a) => {
        if (a.payload.selected) {
          s.selected = [...s.selected, a.payload.id];
        } else {
          s.selected = s.selected.filter((x) => x !== a.payload.id);
        }
      })
      .addCase(TrashActions.selectorAllChanged, (s, a) => {
        s.selected = a.payload.ids;
      });
  },
);
